// = Libs =
import { AxiosRequestConfig, AxiosResponse } from 'axios';

// = Constants =
import { API_INSTANCE } from '@/constants/api';

// = Types =
interface RequestParamsType {
  url: string;
  method: 'get' | 'post' | 'put' | 'delete' | 'patch';
  body?: Record<string, any>;
  headers?: Record<string, any>;
}

interface RequestReturnType<Data> {
  data: Data | undefined;
  error: string;
  headers?: any;
}

const sendRequest = async <T extends Object>(
  params: RequestParamsType,
  INSTANCE = API_INSTANCE,
  ...rest: AxiosRequestConfig[]
): Promise<RequestReturnType<T>> => {
  const { method, url, headers, body } = params;

  const response: RequestReturnType<T> = {
    data: undefined,
    error: '',
    headers: undefined,
  };

  try {
    const { data, headers: responseHeaders } = await INSTANCE.request<T>({
      method,
      headers,
      data: body,
      url,
      ...rest,
    });
    response.data = data;
    response.headers = responseHeaders;
  } catch (error) {
    return Promise.reject({
      error,
      data: undefined,
    });
  }

  return response;
};

export default sendRequest;
